import React, {Component} from 'react';
// import PropTypes from 'prop-types';
// import classnames from 'classnames';
// import styles from './styles.css';

import {Helmet} from "react-helmet";

class Meta extends Component {
  render() {
    const title = this.props.title ? (this.props.title + ' | Dante Kitchen + Bar') : 'Dante Kitchen + Bar';
    const description = this.props.description ? this.props.description : "Новое стильное место в центре на Кузнецком мосту от команды Saxon+Parole";
    const site = (window.location.origin + window.location.pathname) || 'http://dante.moscow';
    const preview = this.props.preview ? this.props.preview : require('./danteshare.jpg');

    return (
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />

        <meta property="og:type" content="website" />
        <meta property="og:site_name" content={'Dante'} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={site} />
        <meta property="og:locale" content="ru_RU" />
        <meta property="og:image" content={preview} />
        <meta property="og:image:width" content="800" />
        <meta property="og:image:height" content="533" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image:src" content={preview} />
        <meta name="twitter:url" content={site}/>
      </Helmet>
    );
  }
}

// Meta.propTypes = {

// };

// Meta.defaultProps = {

// }

export default Meta;


// WEBPACK FOOTER //
// ./src/components/Meta/Meta.js